<div class="selector-control" woa-touchable woa-activatable (onActivate)="activate($event)">
    <div class="selector-control-body" [class.disabled]="disabled()">
        <div class="selector-control-body-indicator"
             [ngClass]="{
                 checkbox: type() === SelectorType.CHECKBOX,
                 radio: type() === SelectorType.RADIO,
                 selected: selected()
             }"></div>
    </div>
    @if (label()) {
        <div class="selector-control-label">
            {{ label() | translate: translationParams() }}
        </div>
    }
</div>
